<template>
    <div class="mb-5">
        <section class="pdf-item">
            <feed-item v-for="item in feed"
                       :feed-data="item"
                       :key="item.id"
                       :forExport="forExport">
            </feed-item>
        </section>
    </div>
</template>

<script>
import FeedItem from './FeedItem';
export default {
    components: {
        FeedItem
    },
    props: ['exportFeed', 'forExport'],
    computed: {
        feed() {
            if(this.exportFeed){
                return this.exportFeed;
            } else{
                return this.$store.state.projects.currentProject.feed;
            }
        }
    },
    created() {
        let projectId = this.$route.params.projectId;
        if(!this.exportFeed){
            this.$store.dispatch("projects/loadFeedByProject", { projectId });
        }
    }
}
</script>

